module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BlackItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BlackItalic.eot
// module id = 11
// module chunks = 8